import React, { useMemo } from 'react';
import { Box, Text } from '@wix/design-system';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
export const NoRecommendations = _ref => {
  let {
    type = 'default'
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  const text = useMemo(() => {
    switch (type) {
      case 'default':
        return t('domain_search_suite.error.no_domain_no_suggestions');
      case 'anonymous':
        return t('domain_search_suite.storefront_results.error.no_domain_with_suggestions');
    }
  }, [type, t]);
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    width: "100%",
    alignContent: "center",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, text));
};
//# sourceMappingURL=NoRecommendations.js.map